/**
 * Public URL where the Agent Flow (Next.js) app is deployed.
 *
 * On Vercel: add this to the **WinXP** project as an Environment Variable
 * (Production + Preview) so each build bakes in the correct link:
 *   REACT_APP_AGENT_FLOW_URL = https://<your-agent-flow-deployment>.vercel.app
 *
 * Default matches a second Vercel project named `mahip-xp-learn` (see VERCEL.md).
 */
export const AGENT_FLOW_COURSE_URL =
  process.env.REACT_APP_AGENT_FLOW_URL || 'https://mahip-xp-learn.vercel.app';
